import './styles.scss';

// captures the whole link including brackets so we can split on it
const SPLIT_REGEX = /(\[[^\]]+\]\([^)]+\))/g;
// captures the text and url in separate groups so we can iterate over them
const LINK_REGEX = /^\[([^\]]+)\]\(([^)]+)\)$/;

interface OAuthConsentNoticeProps {
  notice: string;
}

export function OAuthConsentNotice({ notice }: OAuthConsentNoticeProps) {
  const segments = notice.split(SPLIT_REGEX);
  const hasLinks = segments.some((s) => LINK_REGEX.test(s));

  if (!hasLinks) return <p className="oauth-consent-notice">{notice}</p>;

  const parts = segments.map((segment, i) => {
    const match = LINK_REGEX.exec(segment);
    if (match) {
      const [, text, url] = match;

      return (
        <a key={i} href={url} target="_blank" rel="noreferrer">
          {text}
        </a>
      );
    }

    return segment ? <span key={i}>{segment}</span> : undefined;
  });

  return <p className="oauth-consent-notice">{parts}</p>;
}
